import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useImageConfirmMutation = createMutationHook(
  MembershipsCreatorApiClient.confirmImageUpload,
  {
    mutationKey: ['imageConfirm'],
  },
)
